import React, { useEffect, useRef } from "react";
import { IMAGES } from "../images/images";
import { Button, Col, Container, Form, Image, Row } from "react-bootstrap";
import { Icon } from "@iconify/react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../common/Loader";
import AOS from "aos";
import { Link } from "react-router-dom";

const Home = () => {
  // LOGICAL VARIABLES
  useEffect(() => {
    AOS.init({
      // ... your other initialisation options here ...
      once: true,
    });
  }, []);

  const [email, setEmail] = React.useState("");

  const [loading, setLoading] = React.useState(false);
  const [hover1, sethover1] = React.useState(false);
  const [hover2, sethover2] = React.useState(false);
  const [hover3, sethover3] = React.useState(false);
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };
  const SendMail = async () => {
    if (!validateEmail(email)) {
      toast.error("S'il vous plaît, mettez une adresse email valide.");
      return;
    }

    try {
      setLoading(true);
      await fetch("https://omni-cave.com/backend/api/v1/auth/mail-send", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: email }),
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.success) {
            setLoading(false);
            setEmail("");
            toast.success(
              `Vous vous êtes inscrit avec succès au lancement de notre application. Nous vous informerons lorsqu'elle sera prête à être téléchargée. Nous vous remercions pour l'attention que vous portez à OmniCave !`
            );
          } else {
            setLoading(false);
            toast.error(res.message);
          }
        });
    } catch (error) {
      setLoading(false);
      toast.error("L'inscription a échoué, veuillez réessayer.");
      console.error("Error:", error);
    }
  };

  const navbarToggleRef = useRef(null);
  const navbarCollapseRef = useRef(null);

  const scrollToSection = (id) => {
    document.getElementById(id).scrollIntoView({
      behavior: "smooth",
    });

    // Toggle the collapse state of the navbar
    if (
      navbarToggleRef.current &&
      navbarCollapseRef.current.classList.contains("show")
    ) {
      navbarToggleRef.current.click();
    }
  };

  return (
    <React.Fragment ref={navbarToggleRef}>
      <section
        className="bannerSection"
        style={{ backgroundImage: `url(${IMAGES.BannerImg})` }}
      >
        <Container>
          <Row className="align-items-center">
            <Col md={6} data-aos="fade-left" data-aos-duration="1200">
              <h1>
                Vendez et achetez vos <br /> <span>vins entre particuliers, en toute sécurité</span>
              </h1>
              <div className="banner-intro">
                <p>
                  OmniCave est la première plateforme dédiée à la vente de vins entre particuliers.
                  Paiement sécurisé via compte séquestre, suivi d’envoi avec Sendcloud et frais parmi les plus bas du
                  marché : échangez vos bouteilles en toute confiance.
                </p>
                <p>
                  <strong>Offre limitée à 300 membres.</strong> Les premiers inscrits obtiennent un badge «&nbsp;Membre
                  fondateur&nbsp;» et des frais de vente gratuits à vie.
                </p>
              </div>
              <button
                type="button"
                className="appComBox"
                onClick={() => scrollToSection("registeryourself")}
              >
                <span className="appComBox__label">Je rejoins les 300 membres fondateurs</span>
                <span className="appComBox__pill">Gratuit, sans engagement.</span>
              </button>
              <div className="socialLogin banner-socialLogin">
                <Link
                  className="socialLogin-link"
                  to="/"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("registeryourself");
                  }}
                >
                  <Image src={IMAGES.Google_Img} alt="Google Play" />
                  <span className="socialLogin-soon">Coming soon</span>
                </Link>
                <Link
                  className="socialLogin-link"
                  to="/"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("registeryourself");
                  }}
                >
                  <Image src={IMAGES.AppStore_Img} alt="App Store" />
                  <span className="socialLogin-soon">Coming soon</span>
                </Link>
              </div>
            </Col>
            <div
              className="col-md-6"
              data-aos="fade-right"
              data-aos-duration="1200"
            >
              <Image src={IMAGES.Bannerimg_Img} className="ban_img" alt="" />
            </div>
          </Row>
        </Container>
      </section>

      <section
        className="registerSection"
        style={{ backgroundImage: `url(${IMAGES.Register_Img})` }}
        id="registeryourself"
      >
        <Container>
          <Row className="justify-content-center">
            <Col md={8}>
              <h2 data-aos="fade-up" data-aos-duration="1000">
                Rejoignez les 300 membres fondateurs
              </h2>
              <p data-aos="fade-up" data-aos-duration="1500">
                Inscrivez-vous pour tester l’application en avant-première, obtenir le badge ‘Membre fondateur’ et
                bénéficier de frais de vente gratuits à vie.
              </p>
              <div
                className="sendbTn"
                data-aos="fade-up"
                data-aos-duration="2000"
              >
                <Form.Control
                  aria-label="Small"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder="Votre adresse email"
                  onChange={(text) => setEmail(text.target.value)}
                  value={email}
                />
                <Button type="button" onClick={() => SendMail()}>
                  {loading ? (
                    <Loader color="white" size={28} />
                  ) : (
                    "Je m\u2019inscris"
                  )}
                </Button>
              </div>
              <p className="text-center" data-aos="fade-up" data-aos-duration="1500" style={{ fontSize: '14px', backgroundColor: 'red', height: '0px' }}>
                Aucune publicité, vous pouvez vous désinscrire à tout moment.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <section id="howitwork" className="commonpad howitwork">
        <Container>
          <Row>
            <Col lg={12} md={12} className="text-center">
              <h3 className="h3" data-aos="fade-up" data-aos-duration="1000">
                Comment ça marche
              </h3>
              <h2 data-aos="fade-up" data-aos-duration="1500">
                Comment l'utiliser
              </h2>
              <p data-aos="fade-up" data-aos-duration="2000">
                Laissez-vous portez par le fonctionnement intuitif OmniCave.
              </p>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col lg={4} md={6}>
              <div
                className="howitwork__body"
                onMouseEnter={() => sethover1(true)}
                onMouseLeave={() => sethover1(false)}
              >
                <div
                  className="numberBox"
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                >
                  <h4>01</h4>
                </div>
                <div data-aos="fade-up" data-aos-duration="1500">
                  <Icon
                    icon="ic:baseline-search"
                    style={{ color: hover1 ? "white" : "#a51d43" }}
                    width="60px"
                    height="60px"
                  />
                </div>
                <h3 data-aos="fade-up" data-aos-duration="1500">
                  Rechercher et explorer les vins
                </h3>
                <p data-aos="fade-up" data-aos-anchor-placement="center-center">
                  Filtrez par région, appellation, millésime ou prix pour trouver la bouteille idéale dans les caves des
                  particuliers.
                </p>
                <Image className="arrowPos" src={IMAGES.Arrow_SVG} />
              </div>
            </Col>
            <Col lg={4} md={6}>
              <div
                className="howitwork__body"
                onMouseEnter={() => sethover2(true)}
                onMouseLeave={() => sethover2(false)}
              >
                <div
                  className="numberBox"
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                >
                  <h4>02</h4>
                </div>
                <div data-aos="fade-up" data-aos-duration="1500">
                  <Icon
                    icon="streamline:payment-10-solid"
                    style={{ color: hover2 ? "white" : "#a51d43" }}
                    width="60px"
                    height="60px"
                  />
                </div>
                <h3 data-aos="fade-up" data-aos-duration="1500">
                  Acheter ou faire une offre
                </h3>
                <p data-aos="fade-up" data-aos-anchor-placement="center-center">
                  Validez l’achat au prix affiché ou faites une offre au vendeur. Le paiement est placé sur un compte
                  séquestre sécurisé jusqu’à réception.
                </p>

                <Image className="arrowPos" src={IMAGES.Arrow_SVG} />
              </div>
            </Col>
            <Col lg={4} md={6}>
              <div
                className="howitwork__body"
                onMouseEnter={() => sethover3(true)}
                onMouseLeave={() => sethover3(false)}
              >
                <div
                  className="numberBox"
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                >
                  <h4>03</h4>
                </div>
                <div data-aos="fade-up" data-aos-duration="1500">
                  <Icon
                    icon="carbon:delivery"
                    style={{ color: hover3 ? "white" : "#a51d43" }}
                    width="60px"
                    height="60px"
                  />
                </div>
                <h3 data-aos="fade-up" data-aos-duration="1500">
                  Recevez votre commande
                </h3>

                <p data-aos="fade-up" data-aos-anchor-placement="center-center">
                  Le vendeur expédie la bouteille avec Sendcloud : vous suivez le colis en temps réel jusqu’à la
                  livraison.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section
        id="howitwork"
        className="commonpad howitwork radiusHardwork"
        style={{ backgroundColor: "#f8f8f8" }}
      >
        <Container>
          <Row>
            <Col lg={12} md={12} className="text-center">
              <h3 className="h3" data-aos="fade-up" data-aos-duration="1000">
                Comment ça marche
              </h3>
              <h2 data-aos="fade-up" data-aos-duration="1500">
                Vendre via Omnicave
              </h2>
              <p data-aos="fade-up" data-aos-duration="2000">
                Débloquez une vente transparente grâce au fonctionnement
                intuitif d’OmniCave.
              </p>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col lg={4} md={6}>
              <div
                className="howitwork__body"
                onMouseEnter={() => sethover1(true)}
                onMouseLeave={() => sethover1(false)}
              >
                <div
                  className="numberBox"
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                >
                  <h4>01</h4>
                </div>
                <div
                  data-aos="fade-up"
                  data-aos-duration="1500"
                  className="imgBox"
                >
                  {/* <Icon
                    icon="ic:baseline-search"
                    style={{ color: hover1 ? "white" : "#a51d43" }}
                    width="60px"
                    height="60px"
                  /> */}
                  <Image src={IMAGES.addUser} alt="" />
                </div>
                <h3 data-aos="fade-up" data-aos-duration="1500">
                  Créer un compte vendeur
                </h3>
                <p data-aos="fade-up" data-aos-anchor-placement="center-center">
                  Créez votre profil en quelques minutes, ajoutez vos informations et préparez-vous à vendre les
                  bouteilles de votre cave.
                </p>
                <Image className="arrowPos" src={IMAGES.Arrow_SVG} />
              </div>
            </Col>
            <Col lg={4} md={6}>
              <div
                className="howitwork__body"
                onMouseEnter={() => sethover2(true)}
                onMouseLeave={() => sethover2(false)}
              >
                <div
                  className="numberBox"
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                >
                  <h4>02</h4>
                </div>
                <div
                  data-aos="fade-up"
                  data-aos-duration="1500"
                  className="imgBox"
                >
                  {/* <Icon
                    icon="streamline:payment-10-solid"
                    style={{ color: hover2 ? "white" : "#a51d43" }}
                    width="60px"
                    height="60px"
                  /> */}
                  <Image src={IMAGES.cellar} alt="" />
                </div>
                <h3 data-aos="fade-up" data-aos-duration="1500">
                  Ajouter des vins à l'inventaire
                </h3>
                <p data-aos="fade-up" data-aos-anchor-placement="center-center">
                  Renseignez le domaine, le millésime, l’état de la bouteille, le prix souhaité et ajoutez quelques photos.
                  Votre vin est visible par toute la communauté.
                </p>

                <Image className="arrowPos" src={IMAGES.Arrow_SVG} />
              </div>
            </Col>
            <Col lg={4} md={6}>
              <div
                className="howitwork__body"
                onMouseEnter={() => sethover3(true)}
                onMouseLeave={() => sethover3(false)}
              >
                <div
                  className="numberBox"
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                >
                  <h4>03</h4>
                </div>
                <div
                  data-aos="fade-up"
                  data-aos-duration="1500"
                  className="imgBox"
                >
                  {/* <Icon
                    icon="carbon:delivery"
                    style={{ color: hover3 ? "white" : "#a51d43" }}
                    width="60px"
                    height="60px"
                  /> */}
                  <Image src={IMAGES.trade} alt="" />
                </div>
                <h3 data-aos="fade-up" data-aos-duration="1500">
                  Vendre directement ou négocier
                </h3>

                <p data-aos="fade-up" data-aos-anchor-placement="center-center">
                  Recevez des demandes ou des offres, discutez avec l’acheteur puis validez la vente.
                  Frais de vente très faibles – et gratuits à vie pour les membres fondateurs.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="commonpad aboutUs" id="aboutus">
        <Container>
          <Row className="align-items-center">
            <Col
              md={6}
              data-aos="fade-left"
              data-aos-duration="1200"
              className="text-center"
            >
              <Image src={IMAGES.About_Img} alt="" className="img-fluid cImg" />
            </Col>
            <Col md={6}>
              <h3 className="h3" data-aos="fade-up" data-aos-duration="1000">
                À PROPOS DE NOUS
              </h3>
              <h2 data-aos="fade-up" data-aos-duration="1300">
                OmniCave est une application pensée pour les amateurs, collectionneurs et passionnés de vin.
              </h2>
              <div data-aos="fade-up" data-aos-duration="1600">
                <p>
                  Notre mission : rendre la vente de vins entre particuliers simple, transparente et sécurisée, sans passer
                  par des intermédiaires coûteux.<br />
                  Grâce au paiement en compte séquestre, au suivi d’envoi avec Sendcloud et à des frais réduits, vous
                  gardez le contrôle sur vos bouteilles tout en rejoignant une communauté d’amateurs éclairés.
                  {" "}
                </p>
                {/* <h6 className="aboutusHeading">Notre mission :</h6> */}
                {/* <p>
                  Notre mission est de rendre le commerce du vin plus
                  transparent et accessible, tout en créant une véritable
                  communauté d’amateurs autour de cette passion commune.{" "}
                </p> */}
                {/* <p>
                  Faciliter la découverte et la vente de vins d'exception entre
                  particuliers. Nous créons une communauté où l'échange se fait
                  en toute confiance.{" "}
                </p> */}
                {/* <h6 className="aboutusHeading">Ce que nous offrons :</h6>
                <p>
                  {" "}
                  Sécurité totale : Transactions protégées jusqu'à la réception
                  de votre bouteille.. <br /> <br /> Vins rares : Accédez à des
                  sélections uniques et introuvables ailleurs. <br />
                  <br /> Communauté passionnée : Partagez vos coups de cœur et
                  suivez vos vendeurs favoris.
                </p>
                <h6 className="aboutusHeading"> Pourquoi choisir OmniCave ?</h6>
                <p>
                  Transparence et confiance : Vendeurs et acheteurs vérifiés.{" "}
                  <br /> <br /> Simplicité : Interface intuitive pour une
                  expérience fluide. <br /> <br />
                  Support :Une équipe dédiée pour vous accompagner.
                </p> */}
              </div>
              {/* <p data-aos="fade-up" data-aos-duration="2000" className="mb-4">
                Duis aute irure dolor in reprehenderit in voluptate velit esse
                cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                cupidatat non proident, sunt in culpa qui officia deserunt
                mollit anim id est laborum.
              </p> */}

              {/* <Link className="btn btn-primary">Read More</Link> */}
            </Col>
          </Row>
        </Container>
      </section>

      <section id="downloadapp" className="commonpad downloadApp">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <div className="downloadApp__content">
                <h3 className="h3" data-aos="fade-up" data-aos-duration="1000">
                  Application mobile
                </h3>
                <h2 data-aos="fade-up" data-aos-duration="1000">
                  {"L\u2019application Omnicave arrive bientôt"}
                </h2>
                <p data-aos="fade-up" data-aos-duration="1000">
                  Nous finalisons actuellement la dernière version de l’application. Inscrivez-vous dès maintenant pour
                  faire partie des 300 premiers testeurs et profiter de frais de vente gratuits à vie.
                </p>

                <button
                  type="button"
                  className="downloadApp__ctaBtn"
                  data-aos="fade-up"
                  data-aos-duration="1200"
                  onClick={() => scrollToSection("registeryourself")}
                >
                  Je deviens membre fondateur
                </button>

                <div className="socialLogin downloadApp__stores">
                  <Link
                    className="socialLogin-link"
                    to="/"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection("registeryourself");
                    }}
                  >
                    <Image src={IMAGES.Google_Img} alt="Google Play" />
                    <span className="socialLogin-soon">Coming soon</span>
                  </Link>
                  <Link
                    className="socialLogin-link"
                    to="/"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection("registeryourself");
                    }}
                  >
                    <Image src={IMAGES.AppStore_Img} alt="App Store" />
                    <span className="socialLogin-soon">Coming soon</span>
                  </Link>
                </div>
              </div>
            </Col>

            <Col md={6}>
              <Image
                src={IMAGES.AppDownload_Img}
                alt=""
                className="img-fluid"
                data-aos="zoom-in"
                data-aos-duration="1500"
              />
            </Col>
          </Row>
        </Container>
      </section>

      <ToastContainer />
    </React.Fragment>
  );
};

export default Home;
